import { render, staticRenderFns } from "./RooofAccountForm.vue?vue&type=template&id=562d3cc0&scoped=true&"
import script from "./RooofAccountForm.vue?vue&type=script&lang=js&"
export * from "./RooofAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./RooofAccountForm.vue?vue&type=style&index=0&id=562d3cc0&lang=scss&scoped=true&"
import style1 from "./RooofAccountForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562d3cc0",
  null
  
)

export default component.exports